import { render, staticRenderFns } from "./enterAmount.vue?vue&type=template&id=1a2f7fe5&scoped=true"
import script from "./enterAmount.vue?vue&type=script&lang=js"
export * from "./enterAmount.vue?vue&type=script&lang=js"
import style0 from "./enterAmount.vue?vue&type=style&index=0&id=1a2f7fe5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f7fe5",
  null
  
)

export default component.exports